export const actionTypes = {
    "SET_ARTIST_DATA": "SET_ARTIST_DATA",
    "UPDATE_ARTIST_SERVICE_LIST": "UPDATE_ARTIST_SERVICE_LIST",
    "ADD_NEW_ARTIST_SERVICE": "ADD_NEW_ARTIST_SERVICE",
    "DELETE_ARTIST_SERVICE": "DELETE_ARTIST_SERVICE",
    "ARTIST_COVER_IMAGES": "ARTIST_COVER_IMAGES",
    "ARTIST_LOOK_BOOK_IMAGES": "ARTIST_LOOK_BOOK_IMAGES",
    "ARTIST_DATA": "ARTIST_DATA",
}